const Light = () => {
	return (
		<svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M8.52539 21.8029C8.52539 21.4774 8.66645 21.1302 8.94857 20.7612L23.7435 2.28792C24.0148 1.9407 24.3077 1.72911 24.6224 1.65316C24.9479 1.5772 25.2355 1.60975 25.485 1.75081C25.7454 1.88102 25.9245 2.09804 26.0221 2.40186C26.1306 2.70567 26.1035 3.06375 25.9408 3.47607L21.0905 16.6597H30.2865C30.6337 16.6597 30.9158 16.7682 31.1328 16.9852C31.3498 17.1914 31.4583 17.4518 31.4583 17.7664C31.4583 18.1028 31.3173 18.45 31.0352 18.8081L16.2402 37.2977C15.969 37.6341 15.6706 37.8402 15.3451 37.9162C15.0304 38.003 14.7428 37.9759 14.4824 37.8348C14.2329 37.7046 14.0538 37.4876 13.9453 37.1838C13.8477 36.8799 13.8802 36.5164 14.043 36.0933L18.8932 22.9097H9.69727C9.35004 22.9097 9.06793 22.8066 8.85091 22.6004C8.6339 22.3834 8.52539 22.1176 8.52539 21.8029Z'
				fill='#0455A3'
			/>
		</svg>
	);
};

export default Light;
